import { useQuery } from "@tanstack/react-query"
import { getBackofficeClusterKeysQuery } from "modules/backoffice/lib/clusters/getBackofficeClusterKeysQuery"

export function useGetBackofficeClusterKeysQuery(
  ...args: Parameters<typeof getBackofficeClusterKeysQuery>
) {
  return useQuery(getBackofficeClusterKeysQuery(...args))
}
